module.exports = {
  colorSwatchSize: 160,
  rootFontSize: 16,
  listItemMargin: 4,
};
